import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GraphService {

  constructor() { }


  graphDataForm(selectedDate, selectedDateType, list, selectedType?) {
    let count = ''
    if (selectedDate == 'selectedCustomerType') {
      count = 'ordersCount'
    }
    if (selectedDate == 'selectedOrderType' || selectedDate == 'selectedDesignerOrderType') {
      count = 'ordersCount'
    }
    if (selectedDate == 'selectedSalesType' || selectedDate == 'selectedDesignerSalesType') {
      count = 'saleAmount'
    }
    if (selectedDate == 'selectedDesignerProductType') {
      count = 'productcount'
    }
    if (selectedType == 'customGraph') {
      count = 'customGraphCount';
      selectedDate = ''
    }
    if ((selectedDateType == '3Y' || selectedType == 'customGraph') && list && list.hasOwnProperty('threeYears') && list.threeYears && list.threeYears.length) {
      let array = [];
      const threeYears = list.threeYears;
      for (let y = 0; y < threeYears.length; y++) {
        if (array.length === 0) {
          let temp = [threeYears[y].year, threeYears[y][count]];
          array.unshift(temp);
        } else {
          const idx = array.findIndex(e => e[0] === threeYears[y].year)
          if (idx == -1) {
            let temp = [threeYears[y].year, threeYears[y][count]];
            array.unshift(temp);
          } else {
            array[idx][1] = array[idx][1] + threeYears[y][count]
          }
        }
      }
      return array;
    }
    if ((selectedDateType == 'YTD' || selectedType == 'customGraph') && list && list.hasOwnProperty('yeartoDate') && list.yeartoDate && list.yeartoDate.length) {
      let array = [
        ['01', 0],
        ['02', 0],
        ['03', 0],
        ['04', 0],
        ['05', 0],
        ['06', 0],
        ['07', 0],
        ['08', 0],
        ['09', 0],
        ['10', 0],
        ['11', 0],
        ['12', 0]
      ];
      const yeartoDate = list.yeartoDate;
      let newArray = [];
      for (let y = 0; y < yeartoDate.length; y++) {
        if (yeartoDate[y].monthName == 'Jan') {
          array[0][1] = array[0][1] + yeartoDate[y][count]
          array[0][0] = `01/${yeartoDate[y].year}`
          newArray.unshift(array[0])
        }
        if (yeartoDate[y].monthName == 'Feb') {
          array[1][1] = array[1][1] + yeartoDate[y][count]
          array[1][0] = `02/${yeartoDate[y].year}`
          newArray.unshift(array[1])
        }
        if (yeartoDate[y].monthName == 'Mar') {
          array[2][1] = array[2][1] + yeartoDate[y][count]
          array[2][0] = `03/${yeartoDate[y].year}`
          newArray.unshift(array[2])
        }
        if (yeartoDate[y].monthName == 'Apr') {
          array[3][1] = array[3][1] + yeartoDate[y][count]
          array[3][0] = `04/${yeartoDate[y].year}`
          newArray.unshift(array[3])
        }
        if (yeartoDate[y].monthName == 'May') {
          array[4][1] = array[4][1] + yeartoDate[y][count]
          array[4][0] = `05/${yeartoDate[y].year}`
          newArray.unshift(array[4])
        }
        if (yeartoDate[y].monthName == 'Jun') {
          array[5][1] = array[5][1] + yeartoDate[y][count]
          array[5][0] = `06/${yeartoDate[y].year}`
          newArray.unshift(array[5])
        }
        if (yeartoDate[y].monthName == 'Jul') {
          array[6][1] = array[6][1] + yeartoDate[y][count]
          array[6][0] = `07/${yeartoDate[y].year}`
          newArray.unshift(array[6])
        }
        if (yeartoDate[y].monthName == 'Aug') {
          array[7][1] = array[7][1] + yeartoDate[y][count]
          array[7][0] = `08/${yeartoDate[y].year}`
          newArray.unshift(array[7])
        }
        if (yeartoDate[y].monthName == 'Sep') {
          array[8][1] = array[8][1] + yeartoDate[y][count]
          array[8][0] = `09/${yeartoDate[y].year}`
          newArray.unshift(array[8])
        }
        if (yeartoDate[y].monthName == 'Oct') {
          array[9][1] = array[9][1] + yeartoDate[y][count]
          array[9][0] = `10/${yeartoDate[y].year}`
          newArray.unshift(array[9])
        }
        if (yeartoDate[y].monthName == 'Nov') {
          array[10][1] = array[10][1] + yeartoDate[y][count]
          array[10][0] = `11/${yeartoDate[y].year}`
          newArray.unshift(array[10])
        }
        if (yeartoDate[y].monthName == 'Dec') {
          array[11][1] = array[11][1] + yeartoDate[y][count]
          array[11][0] = `12/${yeartoDate[y].year}`
          newArray.unshift(array[11])
        }
      }
      newArray = newArray.filter(res => (res[0] as string).split('/').length > 1)
      return newArray.sort((a, b) => (+((a[0] as string).split('/')[1]) > +((b[0] as string).split('/')[1])) ? 1 : ((+((b[0] as string).split('/')[1]) > +((a[0] as string).split('/')[1])) ? -1 : 0));

    }
    if ((selectedDateType == '1Y' || selectedType == 'customGraph') && list && list.hasOwnProperty('oneYear') && list.oneYear && list.oneYear.length) {
      let array = [
        ['01', 0],
        ['02', 0],
        ['03', 0],
        ['04', 0],
        ['05', 0],
        ['06', 0],
        ['07', 0],
        ['08', 0],
        ['09', 0],
        ['10', 0],
        ['11', 0],
        ['12', 0]
      ];
      const oneYear = list.oneYear;
      let newArray = [];
      for (let y = 0; y < oneYear.length; y++) {
        if (oneYear[y].monthName == 'Jan') {
          array[0][1] = array[0][1] + oneYear[y][count]
          array[0][0] = `01/${oneYear[y].year}`
          newArray.unshift(array[0])
        }
        if (oneYear[y].monthName == 'Feb') {
          array[1][1] = array[1][1] + oneYear[y][count]
          array[1][0] = `02/${oneYear[y].year}`
          newArray.unshift(array[1])
        }
        if (oneYear[y].monthName == 'Mar') {
          array[2][1] = array[2][1] + oneYear[y][count]
          array[2][0] = `03/${oneYear[y].year}`
          newArray.unshift(array[2])
        }
        if (oneYear[y].monthName == 'Apr') {
          array[3][1] = array[3][1] + oneYear[y][count]
          array[3][0] = `04/${oneYear[y].year}`
          newArray.unshift(array[3])
        }
        if (oneYear[y].monthName == 'May') {
          array[4][1] = array[4][1] + oneYear[y][count]
          array[4][0] = `05/${oneYear[y].year}`
          newArray.unshift(array[4])
        }
        if (oneYear[y].monthName == 'Jun') {
          array[5][1] = array[5][1] + oneYear[y][count]
          array[5][0] = `06/${oneYear[y].year}`
          newArray.unshift(array[5])
        }
        if (oneYear[y].monthName == 'Jul') {
          array[6][1] = array[6][1] + oneYear[y][count]
          array[6][0] = `07/${oneYear[y].year}`
          newArray.unshift(array[6])
        }
        if (oneYear[y].monthName == 'Aug') {
          array[7][1] = array[7][1] + oneYear[y][count]
          array[7][0] = `08/${oneYear[y].year}`
          newArray.unshift(array[7])
        }
        if (oneYear[y].monthName == 'Sep') {
          array[8][1] = array[8][1] + oneYear[y][count]
          array[8][0] = `09/${oneYear[y].year}`
          newArray.unshift(array[8])
        }
        if (oneYear[y].monthName == 'Oct') {
          array[9][1] = array[9][1] + oneYear[y][count]
          array[9][0] = `10/${oneYear[y].year}`
          newArray.unshift(array[9])
        }
        if (oneYear[y].monthName == 'Nov') {
          array[10][1] = array[10][1] + oneYear[y][count]
          array[10][0] = `11/${oneYear[y].year}`
          newArray.unshift(array[10])
        }
        if (oneYear[y].monthName == 'Dec') {
          array[11][1] = array[11][1] + oneYear[y][count]
          array[11][0] = `12/${oneYear[y].year}`
          newArray.unshift(array[11])
        }
      }
      newArray = newArray.filter(res => (res[0] as string).split('/').length > 1)
      return newArray.sort((a, b) => (+((a[0] as string).split('/')[1]) > +((b[0] as string).split('/')[1])) ? 1 : ((+((b[0] as string).split('/')[1]) > +((a[0] as string).split('/')[1])) ? -1 : 0));

    }
    if ((selectedDateType == '3M' || selectedType == 'customGraph') && list && list.hasOwnProperty('threeMonths') && list.threeMonths && list.threeMonths.length) {
      let array = [
        ['01', 0, false],
        ['02', 0, false],
        ['03', 0, false],
        ['04', 0, false],
        ['05', 0, false],
        ['06', 0, false],
        ['07', 0, false],
        ['08', 0, false],
        ['09', 0, false],
        ['10', 0, false],
        ['11', 0, false],
        ['12', 0, false]
      ];
      const threeMonths = list.threeMonths;
      let newArray = [];
      for (let y = 0; y < threeMonths.length; y++) {
        if (threeMonths[y].monthName == 'Jan') {
          array[0][1] = array[0][1] + threeMonths[y][count];
          array[0][2] = true
          array[0][0] = `01/${threeMonths[y].year}`
          newArray.unshift(array[0])
        }
        if (threeMonths[y].monthName == 'Feb') {
          array[1][1] = array[1][1] + threeMonths[y][count]
          array[1][2] = true
          array[1][0] = `02/${threeMonths[y].year}`
          newArray.unshift(array[1])
        }
        if (threeMonths[y].monthName == 'Mar') {
          array[2][1] = array[2][1] + threeMonths[y][count]
          array[2][2] = true
          array[2][0] = `03/${threeMonths[y].year}`
          newArray.unshift(array[2])
        }
        if (threeMonths[y].monthName == 'Apr') {
          array[3][1] = array[3][1] + threeMonths[y][count]
          array[3][2] = true
          array[3][0] = `04/${threeMonths[y].year}`
          newArray.unshift(array[3])
        }
        if (threeMonths[y].monthName == 'May') {
          array[4][1] = array[4][1] + threeMonths[y][count]
          array[4][2] = true
          array[4][0] = `05/${threeMonths[y].year}`
          newArray.unshift(array[4])
        }
        if (threeMonths[y].monthName == 'Jun') {
          array[5][1] = array[5][1] + threeMonths[y][count]
          array[5][2] = true
          array[5][0] = `06/${threeMonths[y].year}`
          newArray.unshift(array[5])
        }
        if (threeMonths[y].monthName == 'Jul') {
          array[6][1] = array[6][1] + threeMonths[y][count]
          array[6][2] = true
          array[6][0] = `07/${threeMonths[y].year}`
          newArray.unshift(array[6])
        }
        if (threeMonths[y].monthName == 'Aug') {
          array[7][1] = array[7][1] + threeMonths[y][count]
          array[7][2] = true
          array[7][0] = `08/${threeMonths[y].year}`
          newArray.unshift(array[7])
        }
        if (threeMonths[y].monthName == 'Sep') {
          array[8][1] = array[8][1] + threeMonths[y][count]
          array[8][2] = true
          array[8][0] = `09/${threeMonths[y].year}`
          newArray.unshift(array[8])
        }
        if (threeMonths[y].monthName == 'Oct') {
          array[9][1] = array[9][1] + threeMonths[y][count]
          array[9][2] = true
          array[9][0] = `10/${threeMonths[y].year}`
          newArray.unshift(array[9])
        }
        if (threeMonths[y].monthName == 'Nov') {
          array[10][1] = array[10][1] + threeMonths[y][count]
          array[10][2] = true
          array[10][0] = `11/${threeMonths[y].year}`
          newArray.unshift(array[10])
        }
        if (threeMonths[y].monthName == 'Dec') {
          array[11][1] = array[11][1] + threeMonths[y][count]
          array[11][2] = true
          array[11][0] = `12/${threeMonths[y].year}`
          newArray.unshift(array[11])
        }
      }
      return newArray.filter(res => res[2]);
    }
    if ((selectedDateType == '6M' || selectedType == 'customGraph') && list && list.hasOwnProperty('sixMonths') && list.sixMonths && list.sixMonths.length) {
      let array = [
        ['01', 0, false],
        ['02', 0, false],
        ['03', 0, false],
        ['04', 0, false],
        ['05', 0, false],
        ['06', 0, false],
        ['07', 0, false],
        ['08', 0, false],
        ['09', 0, false],
        ['10', 0, false],
        ['11', 0, false],
        ['12', 0, false]
      ];
      const sixMonths = list.sixMonths;
      let newArray = [];
      for (let y = 0; y < sixMonths.length; y++) {
        if (sixMonths[y].monthName == 'Jan') {
          array[0][1] = array[0][1] + sixMonths[y][count];
          array[0][2] = true
          array[0][0] = `01/${sixMonths[y].year}`
          newArray.unshift(array[0])
        }
        if (sixMonths[y].monthName == 'Feb') {
          array[1][1] = array[1][1] + sixMonths[y][count]
          array[1][2] = true
          array[1][0] = `02/${sixMonths[y].year}`
          newArray.unshift(array[1])
        }
        if (sixMonths[y].monthName == 'Mar') {
          array[2][1] = array[2][1] + sixMonths[y][count]
          array[2][2] = true
          array[2][0] = `03/${sixMonths[y].year}`
          newArray.unshift(array[2])
        }
        if (sixMonths[y].monthName == 'Apr') {
          array[3][1] = array[3][1] + sixMonths[y][count]
          array[3][2] = true
          array[3][0] = `04/${sixMonths[y].year}`
          newArray.unshift(array[3])
        }
        if (sixMonths[y].monthName == 'May') {
          array[4][1] = array[4][1] + sixMonths[y][count]
          array[4][2] = true
          array[4][0] = `05/${sixMonths[y].year}`
          newArray.unshift(array[4])
        }
        if (sixMonths[y].monthName == 'Jun') {
          array[5][1] = array[5][1] + sixMonths[y][count]
          array[5][2] = true
          array[5][0] = `06/${sixMonths[y].year}`
          newArray.unshift(array[5])
        }
        if (sixMonths[y].monthName == 'Jul') {
          array[6][1] = array[6][1] + sixMonths[y][count]
          array[6][2] = true
          array[6][0] = `07/${sixMonths[y].year}`
          newArray.unshift(array[6])
        }
        if (sixMonths[y].monthName == 'Aug') {
          array[7][1] = array[7][1] + sixMonths[y][count]
          array[7][2] = true
          array[7][0] = `08/${sixMonths[y].year}`
          newArray.unshift(array[7])
        }
        if (sixMonths[y].monthName == 'Sep') {
          array[8][1] = array[8][1] + sixMonths[y][count]
          array[8][2] = true
          array[8][0] = `09/${sixMonths[y].year}`
          newArray.unshift(array[8])
        }
        if (sixMonths[y].monthName == 'Oct') {
          array[9][1] = array[9][1] + sixMonths[y][count]
          array[9][2] = true
          array[9][0] = `10/${sixMonths[y].year}`
          newArray.unshift(array[9])
        }
        if (sixMonths[y].monthName == 'Nov') {
          array[10][1] = array[10][1] + sixMonths[y][count]
          array[10][2] = true
          array[10][0] = `11/${sixMonths[y].year}`
          newArray.unshift(array[10])
        }
        if (sixMonths[y].monthName == 'Dec') {
          array[11][1] = array[11][1] + sixMonths[y][count]
          array[11][2] = true
          array[11][0] = `12/${sixMonths[y].year}`
          newArray.unshift(array[11])
        }
      }
      return newArray.filter(res => res[2]);
    }
    if ((selectedDateType == '1M' || selectedType == 'customGraph') && list && list.hasOwnProperty('oneMonth') && list.oneMonth && list.oneMonth.length) {
      let array = [
        ['1', 0, false],
        ['2', 0, false],
        ['3', 0, false],
        ['4', 0, false],
        ['5', 0, false],
        ['6', 0, false],
        ['7', 0, false],
        ['8', 0, false],
        ['9', 0, false],
        ['10', 0, false],
        ['11', 0, false],
        ['12', 0, false],
        ['13', 0, false],
        ['14', 0, false],
        ['15', 0, false],
        ['16', 0, false],
        ['17', 0, false],
        ['18', 0, false],
        ['19', 0, false],
        ['20', 0, false],
        ['21', 0, false],
        ['22', 0, false],
        ['23', 0, false],
        ['24', 0, false],
        ['25', 0, false],
        ['26', 0, false],
        ['27', 0, false],
        ['28', 0, false],
        ['29', 0, false],
        ['30', 0, false],
        ['31', 0, false]
      ];
      const oneMonth = list.oneMonth;
      let newArray = [];
      for (let y = 0; y < oneMonth.length; y++) {
        if (oneMonth[y].day == 1) {
          array[0][1] = array[0][1] + oneMonth[y][count];
          array[0][2] = true
          array[0][0] = `${this.getMonth(oneMonth[y].monthName)}/01`
          newArray.unshift(array[0])
        }
        if (oneMonth[y].day == 2) {
          array[1][1] = array[1][1] + oneMonth[y][count]
          array[1][2] = true
          array[1][0] = `${this.getMonth(oneMonth[y].monthName)}/02`
          newArray.unshift(array[1])
        }
        if (oneMonth[y].day == 3) {
          array[2][1] = array[2][1] + oneMonth[y][count]
          array[2][2] = true
          array[2][0] = `${this.getMonth(oneMonth[y].monthName)}/03`
          newArray.unshift(array[2])
        }
        if (oneMonth[y].day == 4) {
          array[3][1] = array[3][1] + oneMonth[y][count]
          array[3][2] = true
          array[3][0] = `${this.getMonth(oneMonth[y].monthName)}/04`
          newArray.unshift(array[3])
        }
        if (oneMonth[y].day == 5) {
          array[4][1] = array[4][1] + oneMonth[y][count]
          array[4][2] = true
          array[4][0] = `${this.getMonth(oneMonth[y].monthName)}/05`
          newArray.unshift(array[4])
        }
        if (oneMonth[y].day == 6) {
          array[5][1] = array[5][1] + oneMonth[y][count]
          array[5][2] = true
          array[5][0] = `${this.getMonth(oneMonth[y].monthName)}/06`
          newArray.unshift(array[5])
        }
        if (oneMonth[y].day == 7) {
          array[6][1] = array[6][1] + oneMonth[y][count]
          array[6][2] = true
          array[6][0] = `${this.getMonth(oneMonth[y].monthName)}/07`
          newArray.unshift(array[6])
        }
        if (oneMonth[y].day == 8) {
          array[7][1] = array[7][1] + oneMonth[y][count]
          array[7][2] = true
          array[7][0] = `${this.getMonth(oneMonth[y].monthName)}/08`
          newArray.unshift(array[7])
        }
        if (oneMonth[y].day == 9) {
          array[8][1] = array[8][1] + oneMonth[y][count]
          array[8][2] = true
          array[8][0] = `${this.getMonth(oneMonth[y].monthName)}/09`
          newArray.unshift(array[8])
        }
        if (oneMonth[y].day == 10) {
          array[9][1] = array[9][1] + oneMonth[y][count]
          array[9][2] = true
          array[9][0] = `${this.getMonth(oneMonth[y].monthName)}/10`
          newArray.unshift(array[9])
        }
        if (oneMonth[y].day == 11) {
          array[10][1] = array[10][1] + oneMonth[y][count]
          array[10][2] = true
          array[10][0] = `${this.getMonth(oneMonth[y].monthName)}/11`
          newArray.unshift(array[10])
        }
        if (oneMonth[y].day == 12) {
          array[11][1] = array[11][1] + oneMonth[y][count]
          array[11][2] = true
          array[11][0] = `${this.getMonth(oneMonth[y].monthName)}/12`
          newArray.unshift(array[11])
        }
        if (oneMonth[y].day == 13) {
          array[12][1] = array[12][1] + oneMonth[y][count]
          array[12][2] = true
          array[12][0] = `${this.getMonth(oneMonth[y].monthName)}/13`
          newArray.unshift(array[12])
        }
        if (oneMonth[y].day == 14) {
          array[13][1] = array[13][1] + oneMonth[y][count]
          array[13][2] = true
          array[13][0] = `${this.getMonth(oneMonth[y].monthName)}/14`
          newArray.unshift(array[13])
        }
        if (oneMonth[y].day == 15) {
          array[14][1] = array[14][1] + oneMonth[y][count]
          array[14][2] = true
          array[14][0] = `${this.getMonth(oneMonth[y].monthName)}/15`
          newArray.unshift(array[14])
        }
        if (oneMonth[y].day == 16) {
          array[15][1] = array[15][1] + oneMonth[y][count]
          array[15][2] = true
          array[15][0] = `${this.getMonth(oneMonth[y].monthName)}/16`
          newArray.unshift(array[15])
        }
        if (oneMonth[y].day == 17) {
          array[16][1] = array[16][1] + oneMonth[y][count]
          array[16][2] = true
          array[16][0] = `${this.getMonth(oneMonth[y].monthName)}/17`
          newArray.unshift(array[16])
        }
        if (oneMonth[y].day == 18) {
          array[17][1] = array[17][1] + oneMonth[y][count]
          array[17][2] = true
          array[17][0] = `${this.getMonth(oneMonth[y].monthName)}/18`
          newArray.unshift(array[17])
        }
        if (oneMonth[y].day == 19) {
          array[18][1] = array[18][1] + oneMonth[y][count]
          array[18][2] = true
          array[18][0] = `${this.getMonth(oneMonth[y].monthName)}/19`
          newArray.unshift(array[18])
        }
        if (oneMonth[y].day == 20) {
          array[19][1] = array[19][1] + oneMonth[y][count]
          array[19][2] = true
          array[19][0] = `${this.getMonth(oneMonth[y].monthName)}/20`
          newArray.unshift(array[19])
        }
        if (oneMonth[y].day == 21) {
          array[20][1] = array[20][1] + oneMonth[y][count]
          array[20][2] = true
          array[20][0] = `${this.getMonth(oneMonth[y].monthName)}/21`
          newArray.unshift(array[20])
        }
        if (oneMonth[y].day == 22) {
          array[21][1] = array[21][1] + oneMonth[y][count]
          array[21][2] = true
          array[21][0] = `${this.getMonth(oneMonth[y].monthName)}/22`
          newArray.unshift(array[21])
        }
        if (oneMonth[y].day == 23) {
          array[22][1] = array[22][1] + oneMonth[y][count]
          array[22][2] = true
          array[22][0] = `${this.getMonth(oneMonth[y].monthName)}/23`
          newArray.unshift(array[22])
        }
        if (oneMonth[y].day == 24) {
          array[23][1] = array[23][1] + oneMonth[y][count]
          array[23][2] = true
          array[23][0] = `${this.getMonth(oneMonth[y].monthName)}/24`
          newArray.unshift(array[23])
        }
        if (oneMonth[y].day == 25) {
          array[24][1] = array[24][1] + oneMonth[y][count]
          array[24][2] = true
          array[24][0] = `${this.getMonth(oneMonth[y].monthName)}/25`
          newArray.unshift(array[24])
        }
        if (oneMonth[y].day == 26) {
          array[25][1] = array[25][1] + oneMonth[y][count]
          array[25][2] = true
          array[25][0] = `${this.getMonth(oneMonth[y].monthName)}/26`
          newArray.unshift(array[25])
        }
        if (oneMonth[y].day == 27) {
          array[26][1] = array[26][1] + oneMonth[y][count]
          array[26][2] = true
          array[26][0] = `${this.getMonth(oneMonth[y].monthName)}/27`
          newArray.unshift(array[26])
        }
        if (oneMonth[y].day == 28) {
          array[27][1] = array[27][1] + oneMonth[y][count]
          array[27][2] = true
          array[27][0] = `${this.getMonth(oneMonth[y].monthName)}/28`
          newArray.unshift(array[27])
        }
        if (oneMonth[y].day == 29) {
          array[28][1] = array[28][1] + oneMonth[y][count]
          array[28][2] = true
          array[28][0] = `${this.getMonth(oneMonth[y].monthName)}/29`
          newArray.unshift(array[28])
        }
        if (oneMonth[y].day == 30) {
          array[29][1] = array[29][1] + oneMonth[y][count]
          array[29][2] = true
          array[29][0] = `${this.getMonth(oneMonth[y].monthName)}/30`
          newArray.unshift(array[29])
        }
        if (oneMonth[y].day == 31) {
          array[30][1] = array[30][1] + oneMonth[y][count]
          array[30][2] = true
          array[30][0] = `${this.getMonth(oneMonth[y].monthName)}/31`
          newArray.unshift(array[30])
        }
      }
      return newArray.filter(res => res[2]);
    }
    if ((selectedDateType == '2W' || selectedType == 'customGraph') && list && list.hasOwnProperty('twoWeeks') && list.twoWeeks && list.twoWeeks.length) {
      let array = [
        ['1', 0, false],
        ['2', 0, false],
        ['3', 0, false],
        ['4', 0, false],
        ['5', 0, false],
        ['6', 0, false],
        ['7', 0, false],
        ['8', 0, false],
        ['9', 0, false],
        ['10', 0, false],
        ['11', 0, false],
        ['12', 0, false],
        ['13', 0, false],
        ['14', 0, false],
        ['15', 0, false],
        ['16', 0, false],
        ['17', 0, false],
        ['18', 0, false],
        ['19', 0, false],
        ['20', 0, false],
        ['21', 0, false],
        ['22', 0, false],
        ['23', 0, false],
        ['24', 0, false],
        ['25', 0, false],
        ['26', 0, false],
        ['27', 0, false],
        ['28', 0, false],
        ['29', 0, false],
        ['30', 0, false],
        ['31', 0, false]
      ];
      const twoWeeks = list.twoWeeks;
      let newArray = [];
      for (let y = 0; y < twoWeeks.length; y++) {
        if (twoWeeks[y].day == 1) {
          array[0][1] = array[0][1] + twoWeeks[y][count];
          array[0][2] = true
          array[0][0] = `${this.getMonth(twoWeeks[y].monthName)}/01`
          newArray.unshift(array[0])
        }
        if (twoWeeks[y].day == 2) {
          array[1][1] = array[1][1] + twoWeeks[y][count]
          array[1][2] = true
          array[1][0] = `${this.getMonth(twoWeeks[y].monthName)}/02`
          newArray.unshift(array[1])
        }
        if (twoWeeks[y].day == 3) {
          array[2][1] = array[2][1] + twoWeeks[y][count]
          array[2][2] = true
          array[2][0] = `${this.getMonth(twoWeeks[y].monthName)}/03`
          newArray.unshift(array[2])
        }
        if (twoWeeks[y].day == 4) {
          array[3][1] = array[3][1] + twoWeeks[y][count]
          array[3][2] = true
          array[3][0] = `${this.getMonth(twoWeeks[y].monthName)}/04`
          newArray.unshift(array[3])
        }
        if (twoWeeks[y].day == 5) {
          array[4][1] = array[4][1] + twoWeeks[y][count]
          array[4][2] = true
          array[4][0] = `${this.getMonth(twoWeeks[y].monthName)}/05`
          newArray.unshift(array[4])
        }
        if (twoWeeks[y].day == 6) {
          array[5][1] = array[5][1] + twoWeeks[y][count]
          array[5][2] = true
          array[5][0] = `${this.getMonth(twoWeeks[y].monthName)}/06`
          newArray.unshift(array[5])
        }
        if (twoWeeks[y].day == 7) {
          array[6][1] = array[6][1] + twoWeeks[y][count]
          array[6][2] = true
          array[6][0] = `${this.getMonth(twoWeeks[y].monthName)}/07`
          newArray.unshift(array[6])
        }
        if (twoWeeks[y].day == 8) {
          array[7][1] = array[7][1] + twoWeeks[y][count]
          array[7][2] = true
          array[7][0] = `${this.getMonth(twoWeeks[y].monthName)}/08`
          newArray.unshift(array[7])
        }
        if (twoWeeks[y].day == 9) {
          array[8][1] = array[8][1] + twoWeeks[y][count]
          array[8][2] = true
          array[8][0] = `${this.getMonth(twoWeeks[y].monthName)}/09`
          newArray.unshift(array[8])
        }
        if (twoWeeks[y].day == 10) {
          array[9][1] = array[9][1] + twoWeeks[y][count]
          array[9][2] = true
          array[9][0] = `${this.getMonth(twoWeeks[y].monthName)}/10`
          newArray.unshift(array[9])
        }
        if (twoWeeks[y].day == 11) {
          array[10][1] = array[10][1] + twoWeeks[y][count]
          array[10][2] = true
          array[10][0] = `${this.getMonth(twoWeeks[y].monthName)}/11`
          newArray.unshift(array[10])
        }
        if (twoWeeks[y].day == 12) {
          array[11][1] = array[11][1] + twoWeeks[y][count]
          array[11][2] = true
          array[11][0] = `${this.getMonth(twoWeeks[y].monthName)}/12`
          newArray.unshift(array[11])
        }
        if (twoWeeks[y].day == 13) {
          array[12][1] = array[12][1] + twoWeeks[y][count]
          array[12][2] = true
          array[12][0] = `${this.getMonth(twoWeeks[y].monthName)}/13`
          newArray.unshift(array[12])
        }
        if (twoWeeks[y].day == 14) {
          array[13][1] = array[13][1] + twoWeeks[y][count]
          array[13][2] = true
          array[13][0] = `${this.getMonth(twoWeeks[y].monthName)}/14`
          newArray.unshift(array[13])
        }
        if (twoWeeks[y].day == 15) {
          array[14][1] = array[14][1] + twoWeeks[y][count]
          array[14][2] = true
          array[14][0] = `${this.getMonth(twoWeeks[y].monthName)}/15`
          newArray.unshift(array[14])
        }
        if (twoWeeks[y].day == 16) {
          array[15][1] = array[15][1] + twoWeeks[y][count]
          array[15][2] = true
          array[15][0] = `${this.getMonth(twoWeeks[y].monthName)}/16`
          newArray.unshift(array[15])
        }
        if (twoWeeks[y].day == 17) {
          array[16][1] = array[16][1] + twoWeeks[y][count]
          array[16][2] = true
          array[16][0] = `${this.getMonth(twoWeeks[y].monthName)}/17`
          newArray.unshift(array[16])
        }
        if (twoWeeks[y].day == 18) {
          array[17][1] = array[17][1] + twoWeeks[y][count]
          array[17][2] = true
          array[17][0] = `${this.getMonth(twoWeeks[y].monthName)}/18`
          newArray.unshift(array[17])
        }
        if (twoWeeks[y].day == 19) {
          array[18][1] = array[18][1] + twoWeeks[y][count]
          array[18][2] = true
          array[18][0] = `${this.getMonth(twoWeeks[y].monthName)}/19`
          newArray.unshift(array[18])
        }
        if (twoWeeks[y].day == 20) {
          array[19][1] = array[19][1] + twoWeeks[y][count]
          array[19][2] = true
          array[19][0] = `${this.getMonth(twoWeeks[y].monthName)}/20`
          newArray.unshift(array[19])
        }
        if (twoWeeks[y].day == 21) {
          array[20][1] = array[20][1] + twoWeeks[y][count]
          array[20][2] = true
          array[20][0] = `${this.getMonth(twoWeeks[y].monthName)}/21`
          newArray.unshift(array[20])
        }
        if (twoWeeks[y].day == 22) {
          array[21][1] = array[21][1] + twoWeeks[y][count]
          array[21][2] = true
          array[21][0] = `${this.getMonth(twoWeeks[y].monthName)}/22`
          newArray.unshift(array[21])
        }
        if (twoWeeks[y].day == 23) {
          array[22][1] = array[22][1] + twoWeeks[y][count]
          array[22][2] = true
          array[22][0] = `${this.getMonth(twoWeeks[y].monthName)}/23`
          newArray.unshift(array[22])
        }
        if (twoWeeks[y].day == 24) {
          array[23][1] = array[23][1] + twoWeeks[y][count]
          array[23][2] = true
          array[23][0] = `${this.getMonth(twoWeeks[y].monthName)}/24`
          newArray.unshift(array[23])
        }
        if (twoWeeks[y].day == 25) {
          array[24][1] = array[24][1] + twoWeeks[y][count]
          array[24][2] = true
          array[24][0] = `${this.getMonth(twoWeeks[y].monthName)}/25`
          newArray.unshift(array[24])
        }
        if (twoWeeks[y].day == 26) {
          array[25][1] = array[25][1] + twoWeeks[y][count]
          array[25][2] = true
          array[25][0] = `${this.getMonth(twoWeeks[y].monthName)}/26`
          newArray.unshift(array[25])
        }
        if (twoWeeks[y].day == 27) {
          array[26][1] = array[26][1] + twoWeeks[y][count]
          array[26][2] = true
          array[26][0] = `${this.getMonth(twoWeeks[y].monthName)}/27`
          newArray.unshift(array[26])
        }
        if (twoWeeks[y].day == 28) {
          array[27][1] = array[27][1] + twoWeeks[y][count]
          array[27][2] = true
          array[27][0] = `${this.getMonth(twoWeeks[y].monthName)}/28`
          newArray.unshift(array[27])
        }
        if (twoWeeks[y].day == 29) {
          array[28][1] = array[28][1] + twoWeeks[y][count]
          array[28][2] = true
          array[28][0] = `${this.getMonth(twoWeeks[y].monthName)}/29`
          newArray.unshift(array[28])
        }
        if (twoWeeks[y].day == 30) {
          array[29][1] = array[29][1] + twoWeeks[y][count]
          array[29][2] = true
          array[29][0] = `${this.getMonth(twoWeeks[y].monthName)}/30`
          newArray.unshift(array[29])
        }
        if (twoWeeks[y].day == 31) {
          array[30][1] = array[30][1] + twoWeeks[y][count]
          array[30][2] = true
          array[30][0] = `${this.getMonth(twoWeeks[y].monthName)}/31`
          newArray.unshift(array[30])
        }
      }
      return newArray.filter(res => res[2]);
    }
    if ((selectedDateType == '1W' || selectedType == 'customGraph') && list && list.hasOwnProperty('oneWeek') && list.oneWeek && list.oneWeek.length) {
      let array = [
        ['1', 0, false],
        ['2', 0, false],
        ['3', 0, false],
        ['4', 0, false],
        ['5', 0, false],
        ['6', 0, false],
        ['7', 0, false],
        ['8', 0, false],
        ['9', 0, false],
        ['10', 0, false],
        ['11', 0, false],
        ['12', 0, false],
        ['13', 0, false],
        ['14', 0, false],
        ['15', 0, false],
        ['16', 0, false],
        ['17', 0, false],
        ['18', 0, false],
        ['19', 0, false],
        ['20', 0, false],
        ['21', 0, false],
        ['22', 0, false],
        ['23', 0, false],
        ['24', 0, false],
        ['25', 0, false],
        ['26', 0, false],
        ['27', 0, false],
        ['28', 0, false],
        ['29', 0, false],
        ['30', 0, false],
        ['31', 0, false]
      ];
      const oneWeek = list.oneWeek;
      let newArray = [];
      for (let y = 0; y < oneWeek.length; y++) {
        if (oneWeek[y].day == 1) {
          array[0][1] = array[0][1] + oneWeek[y][count];
          array[0][2] = true;
          array[0][0] = `${this.getMonth(oneWeek[y].monthName)}/01`;
          newArray.unshift(array[0]);
        }
        if (oneWeek[y].day == 2) {
          array[1][1] = array[1][1] + oneWeek[y][count]
          array[1][2] = true
          array[1][0] = `${this.getMonth(oneWeek[y].monthName)}/02`
          newArray.unshift(array[1]);
        }
        if (oneWeek[y].day == 3) {
          array[2][1] = array[2][1] + oneWeek[y][count]
          array[2][2] = true
          array[2][0] = `${this.getMonth(oneWeek[y].monthName)}/03`
          newArray.unshift(array[2]);
        }
        if (oneWeek[y].day == 4) {
          array[3][1] = array[3][1] + oneWeek[y][count]
          array[3][2] = true
          array[3][0] = `${this.getMonth(oneWeek[y].monthName)}/04`
          newArray.unshift(array[3]);
        }
        if (oneWeek[y].day == 5) {
          array[4][1] = array[4][1] + oneWeek[y][count]
          array[4][2] = true
          array[4][0] = `${this.getMonth(oneWeek[y].monthName)}/05`
          newArray.unshift(array[4]);
        }
        if (oneWeek[y].day == 6) {
          array[5][1] = array[5][1] + oneWeek[y][count]
          array[5][2] = true
          array[5][0] = `${this.getMonth(oneWeek[y].monthName)}/06`
          newArray.unshift(array[5]);
        }
        if (oneWeek[y].day == 7) {
          array[6][1] = array[6][1] + oneWeek[y][count]
          array[6][2] = true
          array[6][0] = `${this.getMonth(oneWeek[y].monthName)}/07`
          newArray.unshift(array[6]);
        }
        if (oneWeek[y].day == 8) {
          array[7][1] = array[7][1] + oneWeek[y][count]
          array[7][2] = true
          array[7][0] = `${this.getMonth(oneWeek[y].monthName)}/08`
          newArray.unshift(array[7]);
        }
        if (oneWeek[y].day == 9) {
          array[8][1] = array[8][1] + oneWeek[y][count]
          array[8][2] = true
          array[8][0] = `${this.getMonth(oneWeek[y].monthName)}/09`
          newArray.unshift(array[8]);
        }
        if (oneWeek[y].day == 10) {
          array[9][1] = array[9][1] + oneWeek[y][count]
          array[9][2] = true
          array[9][0] = `${this.getMonth(oneWeek[y].monthName)}/10`
          newArray.unshift(array[9]);
        }
        if (oneWeek[y].day == 11) {
          array[10][1] = array[10][1] + oneWeek[y][count]
          array[10][2] = true
          array[10][0] = `${this.getMonth(oneWeek[y].monthName)}/11`
          newArray.unshift(array[10]);
        }
        if (oneWeek[y].day == 12) {
          array[11][1] = array[11][1] + oneWeek[y][count]
          array[11][2] = true
          array[11][0] = `${this.getMonth(oneWeek[y].monthName)}/12`
          newArray.unshift(array[11]);
        }
        if (oneWeek[y].day == 13) {
          array[12][1] = array[12][1] + oneWeek[y][count]
          array[12][2] = true
          array[12][0] = `${this.getMonth(oneWeek[y].monthName)}/13`
          newArray.unshift(array[12]);
        }
        if (oneWeek[y].day == 14) {
          array[13][1] = array[13][1] + oneWeek[y][count]
          array[13][2] = true
          array[13][0] = `${this.getMonth(oneWeek[y].monthName)}/14`
          newArray.unshift(array[13]);
        }
        if (oneWeek[y].day == 15) {
          array[14][1] = array[14][1] + oneWeek[y][count]
          array[14][2] = true
          array[14][0] = `${this.getMonth(oneWeek[y].monthName)}/15`
          newArray.unshift(array[14]);
        }
        if (oneWeek[y].day == 16) {
          array[15][1] = array[15][1] + oneWeek[y][count]
          array[15][2] = true
          array[15][0] = `${this.getMonth(oneWeek[y].monthName)}/16`
          newArray.unshift(array[15]);
        }
        if (oneWeek[y].day == 17) {
          array[16][1] = array[16][1] + oneWeek[y][count]
          array[16][2] = true
          array[16][0] = `${this.getMonth(oneWeek[y].monthName)}/17`
          newArray.unshift(array[16]);
        }
        if (oneWeek[y].day == 18) {
          array[17][1] = array[17][1] + oneWeek[y][count]
          array[17][2] = true
          array[17][0] = `${this.getMonth(oneWeek[y].monthName)}/18`
          newArray.unshift(array[17]);
        }
        if (oneWeek[y].day == 19) {
          array[18][1] = array[18][1] + oneWeek[y][count]
          array[18][2] = true
          array[18][0] = `${this.getMonth(oneWeek[y].monthName)}/19`
          newArray.unshift(array[18]);
        }
        if (oneWeek[y].day == 20) {
          array[19][1] = array[19][1] + oneWeek[y][count]
          array[19][2] = true
          array[19][0] = `${this.getMonth(oneWeek[y].monthName)}/20`
          newArray.unshift(array[19]);
        }
        if (oneWeek[y].day == 21) {
          array[20][1] = array[20][1] + oneWeek[y][count]
          array[20][2] = true
          array[20][0] = `${this.getMonth(oneWeek[y].monthName)}/21`
          newArray.unshift(array[20]);
        }
        if (oneWeek[y].day == 22) {
          array[21][1] = array[21][1] + oneWeek[y][count]
          array[21][2] = true
          array[21][0] = `${this.getMonth(oneWeek[y].monthName)}/22`
          newArray.unshift(array[21]);
        }
        if (oneWeek[y].day == 23) {
          array[22][1] = array[22][1] + oneWeek[y][count]
          array[22][2] = true
          array[22][0] = `${this.getMonth(oneWeek[y].monthName)}/23`
          newArray.unshift(array[22]);
        }
        if (oneWeek[y].day == 24) {
          array[23][1] = array[23][1] + oneWeek[y][count]
          array[23][2] = true
          array[23][0] = `${this.getMonth(oneWeek[y].monthName)}/24`
          newArray.unshift(array[23]);
        }
        if (oneWeek[y].day == 25) {
          array[24][1] = array[24][1] + oneWeek[y][count]
          array[24][2] = true
          array[24][0] = `${this.getMonth(oneWeek[y].monthName)}/25`
          newArray.unshift(array[24]);
        }
        if (oneWeek[y].day == 26) {
          array[25][1] = array[25][1] + oneWeek[y][count]
          array[25][2] = true
          array[25][0] = `${this.getMonth(oneWeek[y].monthName)}/26`
          newArray.unshift(array[25]);
        }
        if (oneWeek[y].day == 27) {
          array[26][1] = array[26][1] + oneWeek[y][count]
          array[26][2] = true
          array[26][0] = `${this.getMonth(oneWeek[y].monthName)}/27`
          newArray.unshift(array[26]);
        }
        if (oneWeek[y].day == 28) {
          array[27][1] = array[27][1] + oneWeek[y][count]
          array[27][2] = true
          array[27][0] = `${this.getMonth(oneWeek[y].monthName)}/28`
          newArray.unshift(array[27]);
        }
        if (oneWeek[y].day == 29) {
          array[28][1] = array[28][1] + oneWeek[y][count]
          array[28][2] = true
          array[28][0] = `${this.getMonth(oneWeek[y].monthName)}/29`
          newArray.unshift(array[28]);
        }
        if (oneWeek[y].day == 30) {
          array[29][1] = array[29][1] + oneWeek[y][count]
          array[29][2] = true
          array[29][0] = `${this.getMonth(oneWeek[y].monthName)}/30`
          newArray.unshift(array[29]);
        }
        if (oneWeek[y].day == 31) {
          array[30][1] = array[30][1] + oneWeek[y][count]
          array[30][2] = true
          array[30][0] = `${this.getMonth(oneWeek[y].monthName)}/31`
          newArray.unshift(array[30]);
        }
      }
      return newArray.filter(res => res[2]);
    }
    if ((selectedDateType == 'MAX' || selectedType == 'customGraph') && list && list.hasOwnProperty('maxYears') && list.maxYears && list.maxYears.length) {

      let array = [];
      const maxYears = list.maxYears;
      for (let y = 0; y < maxYears.length; y++) {
        if (array.length === 0) {
          let temp = [maxYears[y].year, maxYears[y][count]];
          array.push(temp);
        } else {
          const idx = array.findIndex(e => e[0] === maxYears[y].year)
          if (idx == -1) {
            let temp = [maxYears[y].year, maxYears[y][count]];
            array.push(temp);
          } else {
            array[idx][1] = array[idx][1] + maxYears[y][count]
          }
        }
      }
      return array;
    }
  }

  getMonth(e) {
    switch (true) {
      case e.includes('Jan'):
        return '01'
      case e.includes('Feb'):
        return '02'
      case e.includes('Mar'):
        return '03'
      case e.includes('Apr'):
        return '04'
      case e.includes('May'):
        return '05'
      case e.includes('Jun'):
        return '06'
      case e.includes('Jul'):
        return '07'
      case e.includes('Aug'):
        return '08'
      case e.includes('Sep'):
        return '09'
      case e.includes('Oct'):
        return '10'
      case e.includes('Nov'):
        return '11'
      case e.includes('Dec'):
        return '12'
    }
  }


  loadChart(data, pointFormat) {
    return {
      chart: {
        backgroundColor: 'rgba(0,0,0,0)'
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'category'
      },
      yAxis: {
        min: 0,
        tickInterval: this.tickInterval(data),
        max: this.tickInterval(data) > 10 ? (this.tickInterval(data) * 10) : 100,
        title: {
          text: ''
        },
        lineColor: 'transparent linear-gradient(261deg, #F94631 0%, #E62566 100%) 0% 0% no-repeat padding-box;', 
        lineWidth: 1,
        gridLineWidth: 0
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      tooltip: {
        pointFormat: pointFormat
      },
      plotOptions: {
        series: {
            pointWidth: 20,
            borderRadiusTopLeft: '20%',
            borderRadiusTopRight: '20%'
        }
      },
      series: [{
        name: '',
        type: 'column',
        color: '#F84631',
        borderColor: '#F84631',
        data: data
      }]
    }
  }

  tickInterval(data) {
    if (!(data && data.length)) {
      return 10
    }
    let value = Math.max.apply(Math, data.map(function (o) { return o[1]; }))
    return (value ? (Math.ceil(value / 100) * 10) : 10)
  }

  formatDate(date = new Date(), m?) {
    var d = new Date(date),
      month = '' + (d.getMonth() + (m ? 0 : 1)),
      day = '' + d.getDate(),
      year = '' + d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }


}
